import api from "./index";
import { GetApiResponse } from "../types/api";
import { AggregationLevel } from "../types/aggregationLevel";
import Cookies from "js-cookie";

const accessToken = () => Cookies.get("accessToken");

export const getAggregationLevelService = async ({
  country,
}: {
  country: string;
}): Promise<GetApiResponse<AggregationLevel[]>> => {
  try {
    const response = await api.get<GetApiResponse<AggregationLevel[]>>(
      "/geography/AggregationLevel",
      {
        headers: {
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
        params: {
          country,
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};
